import React from 'react';

const Avis = () => {
  const testimonials = [
    {
      id: 1,
      name: "MOHAMED ELMACHHONE",
      role: "Formateur Full-stack Web & Design Graphique – Gomycode",
      image: "./image/mohamed.jpeg",
      text: "J'ai eu le plaisir de former Mostafa dans le cadre de Gomycode. C'est un développeur motivé, curieux et très appliqué. Il a rapidement maîtrisé les outils et livré des projets de qualité.",
      rating: 5,
      color: "from-blue-500 to-purple-600"
    },
    {
      id: 2,
      name: "Othmane Rahel",
      role: "Développeur Full Stack | Futur Ingénieur",
      image: "./image/OTHMANE.jpeg",
      text: "Travailler avec Mostafa est toujours un plaisir. Son sérieux, sa logique de développement et sa communication claire rendent chaque collaboration fluide et productive.",
      rating: 5,
      color: "from-purple-500 to-pink-600"
    },
    {
      id: 3,
      name: "SoftSevenArt.com",
      role: "Agence Développement Web",
      image: "./image/softsevenart.jpeg",
      text: "Mostafa a effectué un stage chez nous et s'est distingué par sa maîtrise de Laravel et Voyager. Il a contribué à plusieurs projets de manière efficace et autonome.",
      rating: 5,
      color: "from-green-500 to-blue-600"
    },
    {
      id: 4,
      name: "Ain Elhadth",
      role: "Chaîne d'information",
      image: "./image/ain.jpg",
      text: "Mostafa a su moderniser notre site WordPress avec un design clair et professionnel. Le travail a été livré dans les délais et selon nos exigences.",
      rating: 5,
      color: "from-red-500 to-orange-600"
    },
    {
      id: 5,
      name: "Nouaceur WingsTech",
      role: "Centre de Formation",
      image: "./image/logo.jpg",
      text: "Mostafa a conçu notre site portfolio de formation avec créativité et rigueur. Il a su comprendre notre vision et la transformer en une plateforme efficace.",
      rating: 5,
      color: "from-indigo-500 to-cyan-600"
    },
    {
      id: 6,
      name: "AbdeRahim Bajji",
      role: "Architecte systèmes intelligents & IoT",
      image: "./image/abdo.jpeg",
      text: "Mostafa est un ami et collaborateur sérieux avec qui j'ai travaillé sur plusieurs projets. Son code est propre, son UI intuitive, et sa réactivité toujours au rendez-vous.",
      rating: 5,
      color: "from-yellow-500 to-orange-600"
    }
  ];

  // Create infinite loop by duplicating testimonials
  const infiniteTestimonials = [...testimonials, ...testimonials, ...testimonials];

  const StarRating = ({ rating }) => {
    return (
      <div className="flex space-x-1 justify-center">
        {[...Array(5)].map((_, index) => (
          <svg
            key={index}
            className={`w-4 h-4 transition-all duration-300 ${index < rating ? 'text-yellow-400 scale-110' : 'text-gray-300'}`}
            fill="currentColor"
            viewBox="0 0 20 20"
            aria-hidden="true"
          >
            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
          </svg>
        ))}
      </div>
    );
  };

  return (
    <section id="avis" className="py-20 relative overflow-hidden">
      {/* Background gradient same as Hero */}
      <div className="absolute inset-0 bg-gradient-to-br from-gray-900 via-blue-900 to-purple-900"></div>
      
      {/* Animated Background Pattern */}
      <div className="absolute inset-0 bg-black opacity-10">
        <div 
          className="absolute inset-0 animate-pulse" 
          style={{
            backgroundImage: 'url("data:image/svg+xml,%3Csvg width=\'60\' height=\'60\' viewBox=\'0 0 60 60\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cg fill=\'none\' fill-rule=\'evenodd\'%3E%3Cg fill=\'%23ffffff\' fill-opacity=\'0.05\'%3E%3Ccircle cx=\'30\' cy=\'30\' r=\'2\'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")',
          }}
        />
      </div>

      {/* Floating Elements */}
      <div className="absolute top-20 left-10 w-20 h-20 bg-purple-500/20 rounded-full blur-xl animate-bounce"></div>
      <div className="absolute bottom-20 right-10 w-32 h-32 bg-blue-500/20 rounded-full blur-xl animate-pulse"></div>
      <div className="absolute top-1/2 left-1/4 w-16 h-16 bg-pink-500/20 rounded-full blur-lg animate-spin"></div>

      <div className="text-center mb-16 animate-fade-in relative z-10">
        <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
          Les Avis
        </h2>
      </div>

      <div className="max-w-7xl mx-auto px-4 relative z-10">
        {/* Infinite Carousel Container */}
        <div className="relative overflow-hidden w-full">
          <div 
            className="flex animate-scroll"
            style={{
              width: `${infiniteTestimonials.length * 320}px`,
              animationDuration: `${infiniteTestimonials.length * 5}s`
            }}
          >
            {infiniteTestimonials.map((testimonial, index) => (
              <div 
                key={`${testimonial.id}-${index}`} 
                className="w-80 flex-shrink-0 px-4"
              >
                <div className="group bg-white/10 backdrop-blur-md p-6 rounded-3xl border border-white/20 hover:bg-white/30 hover:border-white/50 transition-all duration-300 max-w-full mx-auto shadow-2xl hover:shadow-purple-500/25 h-full">
                  <div className="text-center mb-6">
                    <div className={`w-16 h-16 bg-gradient-to-br ${testimonial.color} rounded-full flex items-center justify-center text-white font-bold mx-auto mb-4 shadow-lg transition-all duration-300 relative overflow-hidden`}>
                      <img 
                        src={testimonial.image} 
                        alt={testimonial.name}
                        className="w-full h-full object-cover rounded-full"
                        loading="lazy"
                      />
                    </div>
                    <h4 className="font-semibold text-white text-lg mb-1 group-hover:text-purple-300 transition-colors duration-300">
                      {testimonial.name}
                    </h4>
                    <p className="text-gray-300 text-sm mb-3 group-hover:text-gray-200 transition-colors duration-300">
                      {testimonial.role}
                    </p>
                    <StarRating rating={testimonial.rating} />
                  </div>
                  
                  <div className="text-center">
                    <p className="text-gray-200 leading-relaxed italic text-sm group-hover:text-white transition-colors duration-300 px-2">
                      "{testimonial.text}"
                    </p>
                  </div>

                  <div className="absolute top-4 right-4 opacity-20 group-hover:opacity-40 transition-opacity duration-300">
                    <svg className="w-8 h-8 text-purple-400" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z"/>
                    </svg>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Add custom CSS for infinite scroll animation */}
      <style jsx>{`
        @keyframes scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-${testimonials.length * 320}px);
          }
        }
        
        .animate-scroll {
          animation: scroll linear infinite;
          will-change: transform;
        }
      `}</style>
    </section>
  );
};

export default Avis;